export const ModalConstants = {
    HIDE_MODAL: 'HIDE_MODAL',
    SHOW_MODAL: 'SHOW_MODAL'
};
